// Task Replay constants shared by BOTH the Node route (which enforces them) and the
// browser dashboard (which mirrors them for UX/disable). Single source of truth so
// the two can never drift. Keep this module dependency-free — it is bundled into the
// browser build as well as the server.

/** Per-launch (tasks × variants) ceiling — a runaway-bill guard, NOT a Modal limit
 *  (real concurrency is bounded by the run's maxParallel). */
export const MAX_CELLS = 1000

/** Multi-select filter values travel as ONE comma-joined query param (?type=a,b) —
 *  in the dashboard URL and the API alike. A lone value (older links) is the
 *  one-element case. Values are task types / repo names / agent ids, none of which
 *  contain commas. */
export const encodeFilterList = (values: string[]): string => values.join(',')

/** Parse a comma-joined filter param: trimmed, blanks dropped, de-duplicated
 *  (first occurrence wins), capped so a hand-edited URL can't build a huge IN(). */
export function filterList(raw: string | undefined | null): string[] {
  if (!raw) return []
  return [...new Set(raw.split(',').map((v) => v.trim()).filter(Boolean))].slice(0, 100)
}
